import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Notifications from './Notifications';
import useStyles from './AppHeader.style';
import Logo from '../../../../files/img/logo-dark.png';
import HorizontalNav from './HorizontalNav';
import {connect, setStore} from "trim-redux";
import MyWallet from "../../elements/MyWallet";
import {defaultVariabls} from "../../../../config";
import {Translate} from "../../../../config/Translate";
import UserInfo from "./UserInfo";
import Clock from "../../elements/Clock";
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import Button from "@material-ui/core/Button/Button";
import Feature from "../../elements/Feature";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import PowerSettingsNewRoundedIcon from "@material-ui/icons/PowerSettingsNewRounded";
import GetConfirmationButton from "../../elements/GetConfirmationButton";
const handleLogout = () => {
    localStorage.removeItem('ACT');
    localStorage.removeItem('RET');
    window.location.replace(`${defaultVariabls.website}/logOutFromPanel`);
};
const AppHeader = (props) => {
    const classes = useStyles();
    return (
        <>
            <AppBar className={classes.appbar} color='inherit'>
                <Toolbar className={classes.appToolbar}>
                    <Hidden lgUp>
                        <IconButton
                            edge='start'
                            className={classes.menuButton}
                            aria-label='open drawer'
                            onClick={() => setStore({navCollapsed:!props.navCollapsed})}>
                            <MenuIcon className={classes.menuIcon} />
                        </IconButton>
                    </Hidden>
                    <Box style={{
                        cursor: "pointer",
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'center',
                    }}
                         component="a"
                         href={`${defaultVariabls.website}/shop`}
                    >
                        <img
                            className={classes.LayoutLogo}
                            src={`${defaultVariabls.website}/images/epanjere/panjere-logo.png`}
                            alt={Translate.appName}
                        />
                    </Box>
                    <Hidden mdDown>
                        <Box className={classes.headerNav}>
                            <Box className={classes.headerContainer}>
                                <HorizontalNav />
                            </Box>
                        </Box>
                    </Hidden>

                    <Box className={classes.grow} />
                    <Feature check="wallet">
                    <Box>
                        <MyWallet />
                    </Box>
                    </Feature>
                    <Box>
                        <Notifications />
                    </Box>
                    <GetConfirmationButton
                        handleAction={handleLogout}
                        question={Translate.doYouWanaExit}
                        icon={<CheckBoxIcon/>}
                        tooltip={Translate.logOut}
                    >
                        <PowerSettingsNewRoundedIcon style={{color:"#fff"}} fontSize="small"/>
                    </GetConfirmationButton>
                </Toolbar>
            </AppBar>
        </>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
});
export default connect(mstp)(AppHeader);
